import { render } from "./checkbox-school.vue?vue&type=template&id=77e10f0a&scoped=true"
import script from "./checkbox-school.vue?vue&type=script&lang=js"
export * from "./checkbox-school.vue?vue&type=script&lang=js"

import "./checkbox-school.vue?vue&type=style&index=0&id=77e10f0a&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e10f0a"]])

export default __exports__